export const mutations = {
    setCardId(state, card_id) {
        state.card_id = card_id;
    },
};

export default mutations;
